module.exports = __webpack_public_path__ + "static/media/appointment.4893dee5.png";